const STORAGE_KEY = 'trinity.referralCode';

/** Public signup URL with the referring church's code pre-filled. */
export const buildReferralRegisterUrl = (code: string): string =>
  `${window.location.origin}/register?ref=${encodeURIComponent(code.trim())}`;

export const storeReferralCode = (code: string): void => {
  const normalized = code.trim().toUpperCase();
  if (!normalized) return;
  sessionStorage.setItem(STORAGE_KEY, normalized);
};

export const captureReferralCodeFromSearch = (searchParams: URLSearchParams): void => {
  const ref = searchParams.get('ref')?.trim();
  if (ref) storeReferralCode(ref);
};

export const getStoredReferralCode = (): string | undefined => {
  const code = sessionStorage.getItem(STORAGE_KEY)?.trim();
  return code || undefined;
};

export const clearStoredReferralCode = (): void => {
  sessionStorage.removeItem(STORAGE_KEY);
};
